// packages/shared-hooks/src/lead-activity/useCreateLeadComment.ts
//
// `POST /leads/:leadId/comments` — append a new author-owned comment
// (#1085). The success path invalidates the comments list AND the
// activity feed so the freshly-emitted `LEAD_COMMENT_ADDED` row appears
// in both surfaces without a manual refetch.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  LeadCommentResponseSchema,
  type CreateLeadCommentRequest,
  type LeadCommentResponse,
} from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { leadActivityKeys } from './keys.js';

export function useCreateLeadComment(leadId: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<LeadCommentResponse, unknown, CreateLeadCommentRequest>({
    mutationFn: (input) =>
      client.post<LeadCommentResponse>(
        `/leads/${leadId}/comments`,
        input,
        {},
        LeadCommentResponseSchema,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: leadActivityKeys.forLead(leadId) });
    },
  });
}
